import { useMediaQuery } from '@mui/material';
import { BriefDebriefCallDocument, LeadGensUser } from 'types';
import CreateLeadGenForm from './CreateLeadGenForm';
import { Drawer } from '../shared/Drawer';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	refetch?: () => void;
	allLeadGensUser?: LeadGensUser[];
	curr_user?: {
		id: string,
		name: string
	}
}

const CreateLeadGenModal = ({ isOpen, onClose, refetch, allLeadGensUser, curr_user }: Props) => {
	const isMobile = useMediaQuery('(max-width:960px)');
	return (
		<Drawer
			maxHeight="90dvh"
			modalMaxWidth="1000px"
			minHeight={'max-content'}
			backDropColor={'rgba(0, 0, 0, 0.5)'}
			boxShadow="0px -8px 32px 0px #00000040"
			isModal={!isMobile}
			isOpen={isOpen}
			onClose={onClose}
			header={<h1 className="text-2xl font-bold pt-4 px-5">Create Lead Gen</h1>}
			body={
				<div className="p-2">
					<CreateLeadGenForm onClose={onClose} refetchForm={refetch} allLeadGensUser={allLeadGensUser} curr_user={curr_user} />
				</div>
			}
		/>
	);
};

export default CreateLeadGenModal;
